module.exports = __webpack_public_path__ + "static/media/artificial-intelligence.2df7b7c2.svg";